import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const row: CSSObject = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 12,
};

const logo: CSSObject = {
  flex: 'none',
  width: 40,
  height: 40,
  borderRadius: radius.sm,
  background: color.grey50,
  objectFit: 'contain',
};

const info: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  flex: 1,
  minWidth: 0,
};

const title: CSSObject = {
  fontSize: 15,
  fontWeight: 600,
  color: color.text,
  wordBreak: 'break-all',
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textSub,
  wordBreak: 'keep-all',
  overflowWrap: 'anywhere',
};

export { row, logo, info, title, meta };
